export const SET_ACTIVE_PROMO = 'SET_ACTIVE_PROMO'

export const selectedPromo = activePromo => ({
	type: SET_ACTIVE_PROMO,
	payload: activePromo
})

export default function setActivePromo(activePromo) {
	return dispatch => {
		dispatch(selectedPromo(activePromo))
	}
}



// WEBPACK FOOTER //
// ./src/actions/activePromoActions.js